export default __webpack_public_path__ + "static/media/storno-detailE.c2202a28.png";